import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type Language =
    | 'de'
    | 'en'
    | 'fr'
    | 'es'
    | 'br'
    | 'zh'
    | 'cs'
    | 'hi'
    | 'id'
    | 'ja'
    | 'ko'
    | 'no'
    | 'pl'
    | 'ru'
    | 'se'
    | 'th'
    | 'tr'
    | 'ua';

export interface LanguageState {
  language: Language;
}

const getLanguageFromBrowser = (): Language => {
  // `navigator.language` gibt die bevorzugte Sprache des Browsers zurück (z.B. "de-DE", "en-US")
  const browserLanguage = navigator.language || navigator.languages[0];

  if (browserLanguage.startsWith("de")) {
    return "de";
  } else if (browserLanguage.startsWith("en")) {
    return "en";
  }

  return "de"; // Standardwert "DE"
};

const initialState: LanguageState = {
  language:
    (localStorage.getItem("language") as Language) || // Erste Ebene: localStorage
    getLanguageFromBrowser() || // Zweite Ebene: Browsersprache
    "en", // Dritte Ebene: Standardwert EN
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Language>) => {
      state.language = action.payload;
      localStorage.setItem("language", state.language); // Speichern des Sprachwerts im Local Storage
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export default languageSlice.reducer;
